// @flow

import styled from 'styled-components';
import { PRIMARY_COLOR, WHITE_COLOR } from '../config/constants';

// "NEW" pill rendered next to nav links flagged `isNew`. Shared between the
// global TopMenu and the redesigned homepage nav so both stay in sync.
const NewBadge = styled.span`
  position: absolute;
  top: -13px;
  right: -24px;
  font-size: 10px;
  line-height: 15px;
  letter-spacing: 1.5px;
  background-color: ${PRIMARY_COLOR};
  border-radius: 4px;
  padding: 0 8px;
  transition: none;
  color: ${WHITE_COLOR};
`;

export default NewBadge;
